import {
  object,
  string,
  nonempty,
  optional,
  array,
  integer,
} from "superstruct";

export const bannerSchema = object({
  id: optional(string()),
  name: nonempty(string()),
  provinces: nonempty(array(object())),
  majorGroup: optional(string()),
});

export const promotionSchema = object({
  id: optional(string()),
  name: nonempty(string()),
});

export const territorySchema = object({
  id: optional(string()),
  name: nonempty(string()),
  province: object(),
});

export const productSchema = object({
  id: optional(string()),
  description: nonempty(string()),
  descriptionFr: optional(string()),
  productType: object({ id: nonempty(string()) }),
  manufacturer: object({ id: nonempty(string()) }),
  priceType: object({ id: nonempty(string()) }),
  status: nonempty(string()),
  make: optional(string()),
  upcCode: optional(string()),
  formatQut: string(),
  format: string(),
  prices: optional(array(object())),
});

export const manufacturerSchema = object({
  id: optional(string()),
  name: nonempty(string()),
  status: nonempty(string()),
  civicNo: optional(string()),
  street: optional(string()),
  city: optional(string()),
  province: optional(string()),
  country: optional(string()),
  zipCode: optional(string()),
  telNo: optional(string()),
  noFax: optional(string()),
  username: optional(string()),
  password: optional(string()),
  email: optional(string()),
});

export const photoHashtagSchema = object({
  id: optional(string()),
  hashtag: nonempty(string()),
});

export const hotSheetSchema = object({
  name: nonempty(string()),
  month: nonempty(string()),
  manufacturer: object(),
  provinces: nonempty(array(object())),
  territories: nonempty(array()),
  representatives: nonempty(array()),
  banners: nonempty(array()),
});

export const representativeSchema = object({
  id: optional(string()),
  lastName: nonempty(string()),
  firstName: nonempty(string()),
  territories: array(object()),
  userName: nonempty(string()),
  passwordHint: optional(string()),
  emailAddress: optional(string()),
});

export const storeSchema = object({
  id: optional(string()),
  name: nonempty(string()),
  status: nonempty(string()),
  classification: nonempty(string()),
  civicNo: nonempty(string()),
  street: nonempty(string()),
  office: optional(string()),
  city: nonempty(string()),
  province: object(),
  country: optional(string()),
  postalCode: optional(string()),
  telNo: optional(string()),
  number: integer(),
  webAddress: optional(string()),
  visitFrequency: integer(),
  corpo: optional(string()),
  banner: object(),
  territory: object(),
});
